import { createQuery } from "react-query-kit";

import type { IPhoneCode } from "./types";

import type { AxiosError, IApiResponse, IAxiosFn } from "@api/types";
import { axiosClient } from "@/api/clients";

const key = "options";

type IResponse = IApiResponse<IPhoneCode[]>;
type IVariables = object;

export const getPhoneCodes: IAxiosFn<IVariables, IResponse> = async (
  _,
  signal,
) => {
  const { data } = await axiosClient.get("/dropdown/phone-codes", {
    signal,
  });

  return data;
};

export const usePhoneCodes = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getPhoneCodes(variables, signal),
});
